var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input',_vm._b({ref:"input",attrs:{"value":_vm.innerValue},on:{"click":function($event){return _vm.openLang(_vm.originColumn.field)},"blur":_vm.handleBlur,"change":_vm.handleChange}},'a-input',_vm.cellProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }